import Icon from '../../components/Icon.vue'

Icon.register({"brands/y-combinator":{"width":448,"height":512,"paths":[{"d":"M448 32V480H0V32H448zM236 287.5L313.5 142H280.8L235 233C230.3 242.3 226 251.3 222.2 259.8L210 233 164.8 142H129.8L206.5 285.8V380.3H236V287.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/y-combinator.js
// module id = null
// module chunks = 